import UroSDK, { UroSocket } from 'uro-ai';
import axios from 'axios';
import constants from '../configs/constants';
import reduxStore from '../utils/redux/store';

/**
 * @type {Record<string, UroSDK|UroSocket>}
 */
const instances = {};

/**
 * Returns a singleton UroSDK instance for the current auth token.
 * @returns {UroSDK}
 */
export function getUroSDK() {
  const token = reduxStore.store.getState().auth.token;
  if (!instances[token]) {
    instances[token] = new UroSDK({
      apiKey: token,
      baseUrl: constants.API_URL,
    });
  }
  return /** @type {UroSDK} */ (instances[token]);
}

/**
 * Returns a singleton UroSocket instance for the current auth token.
 * @returns {UroSocket}
 */
export function getUroSocket() {
  const token = reduxStore.store.getState().auth.token;
  const key = `${token}-socket`;
  if (!instances[key]) {
    instances[key] = new UroSocket({
      baseUrl: constants.API_SOCKET_URL,
      token,
    });
  }
  return /** @type {UroSocket} */ (instances[key]);
}

/**
 * List unified jobs (combines image_job and workflow_job with proper pagination)
 * @param {Object} params - Query parameters
 * @param {number} params.page - Page number
 * @param {number} params.limit - Items per page
 * @param {string} [params.status] - Filter by status
 * @param {string} [params.job_type] - Filter by type ('image' or 'workflow')
 * @returns {Promise<Object>} - Paginated jobs response
 */
export async function listUnifiedJobs(params = {}) {
  const token = reduxStore.store.getState().auth.token;
  const queryParams = new URLSearchParams();
  
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.status) queryParams.append('status', params.status);
  if (params.job_type) queryParams.append('job_type', params.job_type);
  if (params.model_id) queryParams.append('model_id', params.model_id);
  if (params.workflow_definition_id) queryParams.append('workflow_definition_id', params.workflow_definition_id);
  
  const response = await axios.get(
    `${constants.API_URL}/jobs?${queryParams.toString()}`,
    {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  );
  
  return response.data;
}

export default { getUroSDK, getUroSocket, listUnifiedJobs };
